import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './ListElement.module.css';
import Icon from '../../../Icon';
import Checkbox from '../../../Checkbox';
import Label from '../../../Label';
import Text from '../../../Text';
import Caption from '../../../Caption';
import Tooltip from '../../../Tooltip';

const bindClasses = classNameBind.bind(styles);

const ListElement = ({
  id,
  name,
  nameCaption,
  label,
  isSelected,
  onSelect,
  disabledTooltipContent,
  drag,
  isDragging,
}) => (
  <div
    className={bindClasses('wrapper', { disabled: !!disabledTooltipContent, isDragging })}
    data-ppuc-id="Transfer.ListElement"
  >
    <div ref={disabledTooltipContent || !drag ? undefined : drag} className={bindClasses('dnd-icon')}>
      <Icon
        color={disabledTooltipContent ? 'light-gray' : 'gray'}
        name="draggable"
      />
    </div>
    <div className={bindClasses('checkbox')}>
      <Tooltip content={disabledTooltipContent}>
        <Checkbox
          id={`checkbox_${id}${disabledTooltipContent ? '_disabled' : ''}`}
          onChange={(e) => { onSelect(e, id); }}
          disabled={!!disabledTooltipContent}
          checked={isSelected}
        />
      </Tooltip>
    </div>
    <div className={bindClasses('names')}>
      <div className={bindClasses('name')}>
        <Label htmlFor={`checkbox_${id}${disabledTooltipContent ? '_disabled' : ''}`} disabled={!!disabledTooltipContent}>{name}</Label>
      </div>
      <div className={bindClasses('name-caption')}>
        <Caption subdued>{nameCaption}</Caption>
      </div>
    </div>
    <div className={bindClasses('label')}>
      <Text>{label}</Text>
    </div>
  </div>
);

ListElement.defaultProps = {
  onSelect: () => {},
};

export default ListElement;
